
import React from 'react';
import '../App.css';

const ListaUtiles = () => {
  const pdfFiles = [
    { title: "Lista de Útiles Pre-Kínder 2026", url:"/pdfs/LISTA  PKINDER 2026.pdf"},
    { title: "Lista de Útiles Kínder 2026", url: "/pdfs/LISTA KÍNDER 2026.pdf" },
    { title: "Lista de Útiles 1° Año Básico 2026", url: "/pdfs/LISTA 1 2026.pdf" },
    { title: "Lista de Útiles 2° Año Básico 2026", url: "/pdfs/LISTA 2 2026.pdf" },
    { title: "Lista de Útiles 3° y 4° Año Básico 2026", url: "/pdfs/LISTA 3y4 2026.pdf" },
    { title: "Lista de Útiles 5° a 8° Año Básico 2026", url: "/pdfs/LISTA 5y8 2026.pdf" },
  ];

  return (
    <div id="listacursos" className="cursos-container">
      <h2 className="junaeb-title">Lista de Útiles Escolares 2026</h2>
      <div className="pdf-list-container">
        {pdfFiles.map((pdf, index) => (
          <div key={index} className="pdf-card">
            <a href={pdf.url} target="_blank" rel="noopener noreferrer">
              {pdf.title}
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ListaUtiles;
